module.exports = __webpack_public_path__ + "img/1484566534.cbe16bb4.jpg";